import { IonContent, IonPage } from "@ionic/react"; // contenedores básicos de Ionic
import Header from "src/components/Header"; // encabezado reutilizable del proyecto
import React from "react"; // React para hooks
import { useParams } from "react-router-dom"; // obtener parámetros de ruta
import EvaluacionAPI from "src/services/evaluacion"; // servicio para obtener evaluación

type RutaParams = { id: string }; // estructura de parámetros de la ruta

// Vista de detalle de Evaluación de Desempeño
const EvaluacionDesempenoDetalle: React.FC = () => { // componente principal
  const { id } = useParams<RutaParams>(); // obtener id de la evaluación desde la URL
  const [data, setData] = React.useState<any>(null); // estado para la evaluación completa
  const [loading, setLoading] = React.useState<boolean>(true); // estado de carga

  React.useEffect(() => { // cargar datos al montar
    const cargar = async () => { // función asíncrona para obtener datos
      try {
        const resp = await EvaluacionAPI.obtener(Number(id)); // invocar API backend
        setData(resp); // guardar datos en estado
      } finally {
        setLoading(false); // terminar estado de carga
      }
    };
    cargar(); // ejecutar carga
  }, [id]); // depender del id

  const fmt = (v: any) => { // formateador corto
    const n = Number(v);
    return Number.isFinite(n) ? n.toFixed(2) : String(v || "0.00");
  }; // fin helper

  return ( // render de la página
    <IonPage> {/* contenedor general */}
      <Header titulo="Detalle de Evaluación" /> {/* encabezado */}
      <IonContent id="evaluacion-de-desempeno-detalle" className="ion-padding"> {/* contenido scrolleable */}
        <div className="container"> {/* contenedor bootstrap */}
          {loading ? ( // mostrar estado de carga
            <div className="text-muted">Cargando...</div>
          ) : !data ? ( // si no hay datos
            <div className="text-danger">No se encontró la evaluación.</div>
          ) : ( // mostrar datos
            <>
              <div className="card mb-3"> {/* resumen final */}
                <div className="card-header bg-em-red text-white">Resumen</div>
                <div className="card-body">
                  <div className="d-flex flex-wrap justify-content-between">
                    <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                      <small>Total: <strong>{data?.cabecera?.puntaje_total ?? data?.final?.total}</strong></small>
                    </div>
                    <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                      <small>Alcanzado: <strong>{fmt(data?.cabecera?.puntaje_alcanzado ?? data?.final?.alcanzado)}</strong></small>
                    </div>
                    <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                      <small>Porcentaje: <strong>{fmt(data?.cabecera?.porcentaje_final ?? data?.final?.porcentaje)}%</strong></small>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card mb-3"> {/* responsabilidades */}
                <div className="card-header">Responsabilidades</div>
                <div className="card-body d-flex flex-wrap justify-content-between">
                  <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                    <small>Totales: <strong>{data?.cabecera?.resp_total ?? data?.totales?.resp?.total}</strong></small>
                  </div>
                  <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                    <small>Alcanzados: <strong>{data?.cabecera?.resp_alc ?? data?.totales?.resp?.alcanzado}</strong></small>
                  </div>
                  <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                    <small>Porcentaje: <strong>{fmt(data?.cabecera?.resp_porcentaje ?? data?.totales?.resp?.porcentaje)}%</strong></small>
                  </div>
                </div>
              </div>

              <div className="card mb-3"> {/* habilidades */}
                <div className="card-header">Habilidades</div>
                <div className="card-body d-flex flex-wrap justify-content-between">
                  <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                    <small>Totales: <strong>{data?.cabecera?.hab_total ?? data?.totales?.hab?.total}</strong></small>
                  </div>
                  <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                    <small>Alcanzados: <strong>{data?.cabecera?.hab_alc ?? data?.totales?.hab?.alcanzado}</strong></small>
                  </div>
                  <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                    <small>Porcentaje: <strong>{fmt(data?.cabecera?.hab_porcentaje ?? data?.totales?.hab?.porcentaje)}%</strong></small>
                  </div>
                </div>
              </div>

              <div className="card mb-3"> {/* indicadores */}
                <div className="card-header">Indicadores</div>
                <div className="card-body d-flex flex-wrap justify-content-between">
                  <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                    <small>Totales: <strong>{data?.cabecera?.ind_total ?? data?.totales?.ind?.total}</strong></small>
                  </div>
                  <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                    <small>Alcanzados: <strong>{fmt(data?.cabecera?.ind_alc ?? data?.totales?.ind?.alcanzado)}</strong></small>
                  </div>
                  <div className="mb-1" style={{ background: "#f5f5f5", padding: "6px 10px", borderRadius: 8 }}>
                    <small>Porcentaje: <strong>{fmt(data?.cabecera?.ind_porcentaje ?? data?.totales?.ind?.porcentaje)}%</strong></small>
                  </div>
                </div>
              </div>

              {data?.resumenes && ( // mostrar sección de resúmenes si viene del backend
                <div className="card mb-3"> {/* resúmenes */}
                  <div className="card-header">Resúmenes</div> {/* encabezado */}
                  <div className="card-body"> {/* cuerpo */}
                    <div className="mb-3"> {/* bloque fortalezas */}
                      <div className="font-weight-bold mb-1">Describa las principales fortalezas</div> {/* título */}
                      <div style={{ whiteSpace: 'pre-wrap' }}>{data.resumenes.fortalezas}</div> {/* texto */}
                    </div>
                    <div className="mb-3"> {/* bloque oportunidades */}
                      <div className="font-weight-bold mb-1">Describa las oportunidades de mejora</div> {/* título */}
                      <div style={{ whiteSpace: 'pre-wrap' }}>{data.resumenes.oportunidades}</div> {/* texto */}
                    </div>
                    <div> {/* bloque capacitaciones */}
                      <div className="font-weight-bold mb-1">Sugerencias de Capacitaciones</div> {/* título */}
                      <div style={{ whiteSpace: 'pre-wrap' }}>{data.resumenes.capacitaciones}</div> {/* texto */}
                    </div>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </IonContent>
    </IonPage>
  );
};

export default EvaluacionDesempenoDetalle; // exportar componente


